import { inject, Injectable, InjectionToken } from '@angular/core';

import { LegalService } from '@valk-nx/services/cookie-manager/src/lib/legal.service';

import { CookieBaseService } from './cookie-base.service';

export const COOKIE_SERVICE_URL = new InjectionToken<string>(
	'cookie-service-url',
);

@Injectable({ providedIn: 'root' })
export class CookieBannerService extends CookieBaseService {
	private readonly cookieServiceUrl = inject(COOKIE_SERVICE_URL);
	private readonly legalService = inject(LegalService);

	protected getCookieServiceUrl(): string {
		return this.cookieServiceUrl;
	}

	getLegal(language: string) {
		return this.legalService.getLegalText(language);
	}
}
